"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FOOTBALL_CONFIGURATION = exports.TwoPointConversionType = exports.TouchdownType = exports.PlayCode = void 0;
var PlayCode;
(function (PlayCode) {
    PlayCode["CompletePass"] = "complete_pass";
    PlayCode["ExtraPoint"] = "extra_point";
    PlayCode["FieldGoal"] = "field_goal";
    PlayCode["Fumble"] = "fumble";
    PlayCode["IncompletePass"] = "incomplete_pass";
    PlayCode["Interception"] = "interception";
    PlayCode["Kickoff"] = "kickoff";
    PlayCode["KickoffReturn"] = "kickoff_return";
    PlayCode["Punt"] = "punt";
    PlayCode["PuntReturn"] = "punt_return";
    PlayCode["Run"] = "run";
    PlayCode["Sack"] = "sack";
    PlayCode["Safety"] = "safety";
    PlayCode["Tackle"] = "tackle";
    PlayCode["Touchdown"] = "touchdown";
    PlayCode["Turnover"] = "turnover";
    PlayCode["TwoPointConversion"] = "two_point_conversion";
})(PlayCode = exports.PlayCode || (exports.PlayCode = {}));
var TouchdownType;
(function (TouchdownType) {
    TouchdownType["Pass"] = "pass";
    TouchdownType["Run"] = "run";
    TouchdownType["Defense"] = "defense";
    TouchdownType["SpecialTeams"] = "special_teams";
})(TouchdownType = exports.TouchdownType || (exports.TouchdownType = {}));
var TwoPointConversionType;
(function (TwoPointConversionType) {
    TwoPointConversionType["Pass"] = "pass";
    TwoPointConversionType["Run"] = "run";
})(TwoPointConversionType = exports.TwoPointConversionType || (exports.TwoPointConversionType = {}));
exports.FOOTBALL_CONFIGURATION = {
    play_codes: Object.values(PlayCode),
};
//# sourceMappingURL=definitions.js.map